import { PageRef } from 'providers/page-ref';

export type AdminTextListPageParams = {};

export const IAdminTextListPage: PageRef<AdminTextListPageParams, void> = {
  pageName: 'AdminTextListPage',
} as PageRef<AdminTextListPageParams, void>;
